/**
 * Classe astratta di gestione 
 * dello localstorage delle cache
 */
export abstract class MapCacheData {
  static MAPCACHE = 'mapcaches';
  /** */
  public static mapname(id: number): string {
    if (id === null) {
      id = 0;
    } else if (id === undefined) {
      id = 0;
    }
    return `mappa-${id}.mbtiles`;
  }
  /**
   *  registra map cahce da id
   * @param id 
   */
  public static registerId(id: number): string[] {
    return MapCacheData.register(MapCacheData.mapname(id));
  }

  /**
   *  deregistra la  cahce da id
   * @param id  da  deregistrare
   */
  public static deregisterId(id: number): string[] {
    return MapCacheData.deregister(MapCacheData.mapname(id));
  }

  /**
   *  Restitusce una Promise che verifica se è verificato per sisotituire 
   * funzione di verifica sul file system
   * @param id  id da cercare
   */
  public static isRegisteredIdP(id: number): Promise<{ id: number, value: boolean }> {
    return Promise.resolve({ id, value: MapCacheData.isRegistered(MapCacheData.mapname(id)) });
  }
  /**
   *  predicato verifica che l'id sia registato come mappcache
   * @param id  id da cercare
   */
  public static isRegisteredId(id: number): boolean {
    return MapCacheData.isRegistered(MapCacheData.mapname(id));
  }

  /**
   * predicvartoverifica che la mappa sia registarta come cache
   * @param mapname 
   */
  public static isRegistered(mapname: string): boolean {
    let maps: string[];
    let mapcaches: string = localStorage.getItem(MapCacheData.MAPCACHE);
    if (mapcaches == null) {
      maps = [];
    } else {
      maps = JSON.parse(mapcaches);
    }
    return (maps.indexOf(mapname) > -1);
  }

  /**
   *  registra una mappa tra le cache disponibili
   * @param mapname  la mappa da registrare
   */
  public static register(mapname: string): string[] {
    let maps: string[];
    let mapcaches: string = localStorage.getItem(MapCacheData.MAPCACHE);
    if (mapcaches == null) {
      maps = [];
    } else {
      maps = JSON.parse(mapcaches);
    }
    if (maps.indexOf(mapname) === -1) {
      maps.push(mapname);
    }
    mapcaches = JSON.stringify(maps);
    localStorage.setItem(MapCacheData.MAPCACHE, mapcaches);
    return maps;
  }
  /**
   * toglie dal registro delle Cache una mappa 
   * @param mapname la mappa da eliminare
   */
  public static deregister(mapname: string): string[] {
    let maps: string[];
    let mapcaches: string = localStorage.getItem(MapCacheData.MAPCACHE);
    if (mapcaches == null) {
      maps = [];
    } else {
      maps = JSON.parse(mapcaches);
    }
    const index = maps.indexOf(mapname);
    if (index > -1) {
      maps.splice(index, 1);
    }
    mapcaches = JSON.stringify(maps);
    localStorage.setItem(MapCacheData.MAPCACHE, mapcaches);
    return maps;
  }

  /**
   * toglie dal registro delle Cache una mappa 
   * @param mapname la mappa da eliminare
   */
  public static get(): string[] {
    let maps: string[];
    const mapcaches: string = localStorage.getItem(MapCacheData.MAPCACHE);
    if (mapcaches == null) {
      maps = [];
    } else {
      maps = JSON.parse(mapcaches);
    }
    return maps;
  }
}
